import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import HowlerPlugin from './utils/howler';
import 'animate.css';
Vue.config.productionTip = false
Vue.use(HowlerPlugin);
document.title = process.env.VUE_APP_TITLE

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
